"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import R from "ramda";
import Vector from "immutable-vector2d";
import { snapToGrid } from "../../annotation/utils";
import Components from "../../annotation/components";
import DrawingUtils from "../../../util/drawing_utils";
import {
  ADDING_MOVED,
  MOVING_MOVED,
  DELETE_COMPONENT,
  CHANGE_COMPONENT_VALUE,
  ADD_COMPONENT,
  CANVAS_SIZE_CHANGED,
  LOADING_ANNOTATIONS_SUCCEEDED,
  LOADING_ANNOTATIONS,
  EDIT_TEXT_ANNOTATION_TEXT
} from "../actions";
import { DRAG_POINT_RADIUS } from "../../annotation/constants";
const { diff } = DrawingUtils;
const translateDragPoints = (dragPointIndex, diffVector) => (dragPoint, idx) => {
  if (idx === dragPointIndex) {
    return dragPoint.subtract(diffVector);
  }
  const matrix = [
    [
      void 0,
      new Vector(dragPoint.x, dragPoint.y - diffVector.y),
      new Vector(dragPoint.x, dragPoint.y),
      new Vector(dragPoint.x - diffVector.x, dragPoint.y)
    ],
    [
      new Vector(dragPoint.x, dragPoint.y - diffVector.y),
      void 0,
      new Vector(dragPoint.x - diffVector.x, dragPoint.y),
      new Vector(dragPoint.x, dragPoint.y)
    ],
    [
      new Vector(dragPoint.x, dragPoint.y),
      new Vector(dragPoint.x - diffVector.x, dragPoint.y),
      void 0,
      new Vector(dragPoint.x, dragPoint.y - diffVector.y)
    ],
    [
      new Vector(dragPoint.x - diffVector.x, dragPoint.y),
      new Vector(dragPoint.x, dragPoint.y),
      new Vector(dragPoint.x, dragPoint.y - diffVector.y),
      void 0
    ]
  ];
  return matrix[dragPointIndex][idx];
};
function translateView(dragPointIndex, diffVector, origPosition, origSize) {
  const x = _.contains([1, 2], dragPointIndex) ? origPosition.x : origPosition.x - diffVector.x;
  const y = _.contains([0, 1], dragPointIndex) ? origPosition.y - diffVector.y : origPosition.y;
  const width = _.contains([1, 2], dragPointIndex) ? origSize.width - diffVector.x : origSize.width + diffVector.x;
  const height = _.contains([2, 3], dragPointIndex) ? origSize.height - diffVector.y : origSize.height + diffVector.y;
  return { x, y, width, height };
}
function diffMax(diffVector, minX, minY, dragPointIndex) {
  return [
    { x: Math.max(diffVector.x, minX * -1), y: Math.max(diffVector.y, minY * -1) },
    { x: Math.min(diffVector.x, minX), y: Math.max(diffVector.y, minY * -1) },
    { x: Math.min(diffVector.x, minX), y: Math.min(diffVector.y, minY) },
    { x: Math.max(diffVector.x, minX * -1), y: Math.min(diffVector.y, minY) }
  ][dragPointIndex];
}
function moveSingleDragPoint(views, action) {
  const { guid, from, dragPointIndex, origDragPoints, origPosition, origSize } = action.movingComponent;
  const diffVector = diffMax(
    diff(from, action.mouseVector),
    origDragPoints[1].x - origDragPoints[0].x - DRAG_POINT_RADIUS * 2,
    origDragPoints[2].y - origDragPoints[1].y - DRAG_POINT_RADIUS * 2,
    dragPointIndex
  );
  const view = views[guid];
  const dragPoints = origDragPoints.map(translateDragPoints(dragPointIndex, diffVector));
  const newView = translateView(dragPointIndex, diffVector, origPosition, origSize);
  return __spreadProps(__spreadValues({}, views), {
    [guid]: __spreadProps(__spreadValues(__spreadValues({}, view), newView), {
      dragPoints
    })
  });
}
function moveWholeComponent(views, action) {
  const { guid, from, origDragPoints, origPosition } = action.movingComponent;
  const view = views[guid];
  const diffVector = diff(from, action.mouseVector);
  const newPos = origPosition.subtract(diffVector);
  const dragPoints = origDragPoints.map((v) => v.subtract(diffVector));
  return __spreadProps(__spreadValues({}, views), {
    [guid]: __spreadProps(__spreadValues({}, view), {
      dragPoints,
      x: newPos.x,
      y: newPos.y
    })
  });
}
function scaleProp(prop, scale) {
  return prop * scale;
}
function scaleDragPoints(dragPoints, scale) {
  return dragPoints.map((p) => {
    return p.multiply(scale);
  });
}
function scaleView(view, action) {
  const { oldCanvasSize, width } = action;
  const scale = width / oldCanvasSize.width;
  return __spreadProps(__spreadValues({}, view), {
    x: scaleProp(view.x, scale),
    y: scaleProp(view.y, scale),
    width: scaleProp(view.width, scale),
    height: scaleProp(view.height, scale),
    dragPoints: scaleDragPoints(view.dragPoints, scale)
  });
}
function scaleViews(views, action) {
  const { oldCanvasSize } = action;
  if (_.isUndefined(oldCanvasSize)) {
    return views;
  }
  return _.mapObject(views, (val) => {
    return scaleView(val, action);
  });
}
function annotationToView(annotation, canvas) {
  const Component = Components[annotation.type];
  const x = annotation.left / 100 * canvas.width;
  const y = annotation.top / 100 * canvas.height;
  const width = annotation.width / 100 * canvas.width;
  const height = annotation.height / 100 * canvas.height;
  const dragPoints = Component.calculateDragPoints(x, y, width, height);
  return {
    dragPoints,
    guid: annotation.guid,
    id: annotation.id,
    typeID: annotation.type,
    height,
    width,
    data: annotation.data,
    x,
    y
  };
}
export default function viewsReducer(views = {}, action) {
  switch (action.type) {
    case ADDING_MOVED: {
      const { start, guid, typeID, id } = action.addingComponent;
      const startPoint = snapToGrid(Vector.fromObject(start));
      const mousePos = Vector.fromObject(action.coords);
      if (snapToGrid(mousePos).equals(startPoint)) {
        return views;
      }
      const Component = Components[typeID];
      const dragPoint = Component.dragPoint(mousePos, { fixed: startPoint });
      const dragPoints = [startPoint, dragPoint];
      return __spreadProps(__spreadValues({}, views), {
        [guid]: {
          typeID,
          guid,
          id,
          value: Component.defaultValue,
          dragPoints
        }
      });
    }
    case ADD_COMPONENT: {
      const { x, y, width, height, guid, typeID } = action;
      const Component = Components[typeID];
      const dragPoints = Component.calculateDragPoints(x, y, width, height);
      return __spreadProps(__spreadValues({}, views), {
        [guid]: {
          typeID,
          guid,
          dragPoints,
          x,
          y,
          width,
          height,
          data: {}
        }
      });
    }
    case LOADING_ANNOTATIONS: {
      return {};
    }
    case LOADING_ANNOTATIONS_SUCCEEDED: {
      const { annotations, canvas } = action;
      return _.object(
        annotations.map((a) => a.guid),
        annotations.map((a) => annotationToView(a, canvas))
      );
    }
    case MOVING_MOVED: {
      const { hoveredComponent } = action;
      const { dragPointIndex } = hoveredComponent;
      if (R.is(Number, dragPointIndex) && dragPointIndex >= 0) {
        return moveSingleDragPoint(views, action);
      }
      return moveWholeComponent(views, action);
    }
    case DELETE_COMPONENT: {
      return R.dissoc(action.guid, views);
    }
    case CHANGE_COMPONENT_VALUE: {
      return __spreadProps(__spreadValues({}, views), {
        [action.guid]: __spreadProps(__spreadValues({}, views[action.guid]), {
          value: action.value
        })
      });
    }
    case CANVAS_SIZE_CHANGED: {
      return scaleViews(views, action);
    }
    case EDIT_TEXT_ANNOTATION_TEXT: {
      const { guid, value } = action;
      return __spreadProps(__spreadValues({}, views), {
        [guid]: __spreadProps(__spreadValues({}, views[guid]), {
          data: { text: value }
        })
      });
    }
    default:
      return views;
  }
}
